import React from "react";
import { useState, useEffect, useRef, useMemo, useContext, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import { getProject } from "../../actions/index";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import * as FiIcons from "react-icons/fi";
import { FirebaseContext } from '../../FirebaseContext';
import jsPDF from 'jspdf';
import { actlistData } from "../../actions/index";
import { BASE_PATH } from "../../constants/Global";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { playerlistData,teamlistData, setisfirsttime, catlistData } from "../../actions/index";
import { canReuseAuctionList, withAuctionAid } from "../../utils/listCache";
import { encode } from "base-64";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { teamdefaultLogo } from "../../constants/Images";
import { applogo } from "../../constants/Images";
import ReactTooltip from "react-tooltip";
import NotFound from "../include/NotFound";
import { getDatabase, ref, remove, onValue, set, update, get } from "firebase/database";
import BounceLoader from "react-spinners/ClipLoader";
// import React, { useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { MdDragIndicator } from "react-icons/md";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import { faTableCellsLarge } from '@fortawesome/free-solid-svg-icons'
const ItemType = 'TEAM';

const DraggableTeamRow = ({ team, index, path, moveTeam, onDragEnd, onDelete }) => {
  const rowRef = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: () => ({ index, tid: team.tid }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: () => {
      onDragEnd();
    },
  });

  const [{ isOver }, drop] = useDrop({
    accept: ItemType,
    collect: (monitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
    hover: (draggedItem, monitor) => {
      if (!rowRef.current) return;

      const dragIndex = draggedItem.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = rowRef.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Only move when the cursor crosses half of the target item
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

      moveTeam(dragIndex, hoverIndex);
      draggedItem.index = hoverIndex;
    },
  });

  drag(drop(rowRef));

  return (
    <li
      ref={rowRef}
      className="liview"
      style={{
        cursor: "move",
        opacity: isDragging ? 0.4 : 1,
        background: isOver && !isDragging ? "#eef6ff" : undefined,
        transition: "background 0.15s ease, opacity 0.15s ease",
      }}
    >
      <div className="liflex t-liflex">
        <div className="t-li1" style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <MdDragIndicator
            size={22}
            style={{ color: "#94a3b8", flexShrink: 0 }}
            aria-hidden="true"
          />
          <div className="li-tlogo">
            <Image
              fallback={teamdefaultLogo}
              src={
                team.logo == "" || team.logo == null
                  ? teamdefaultLogo
                  : path + team.logo
              }
            ></Image>
          </div>
          <div className="t-l-tname">{team.name}</div>
        </div>
        <div className="t-li2">
          <div className="tliner t-l-sname"><b>{team.sname}</b></div>
          <div className="tliner t-l-skey"><b>{team.srtkey}</b></div>
          <div className="liinner">
            <Link
              style={{
                color: "#186cc2",
                padding: "0 18px",
              }}
              to={"/edit-auction-team/" + encode(team.tid)}
              onClick={(e) => e.stopPropagation()}
              draggable={false}
            >
              <AiIcons.AiOutlineEdit
                size={"20px"}
                style={{ color: "green" }}
              />
            </Link>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(team.tid);
              }}
              style={{ background: 'transparent', border: 'none', padding: 0, color: 'red', cursor: 'pointer' }}
              aria-label="Delete team"
            >
              <AiIcons.AiOutlineDelete size={"20px"} />
            </button>
          </div>
        </div>
      </div>
    </li>
  );
};

function Team(match) {
  const reff = useRef(null);
  const { upddata } = useContext(FirebaseContext);
  const profile = useSelector((state) => state.setUserlog);

  const acname = localStorage.getItem("auction_name");

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [pldata, setplData] = useState([]);
  const [catdata, setcatData] = useState([]);
  const [aucdata, setaucdata] = useState([]);
  const [path, setpath] = useState();
  const [isActive, setActive] = useState(false);
  const [islist, setislist] = useState(false);
  const [players, setaucplayer] = useState("");
  const getpageData = useSelector((state) => state.setteamlistData);
  const getaucdata = useSelector((state) => state.setactlistData);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const getplayerpageData = useSelector((state) => state.setplayerlistData);
  const getcatpageData = useSelector((state) => state.setcatlistData);

  const loginuser = useSelector((state) => state.setUserlog);
  const aid = localStorage.getItem("auction_id");
  const [cid, setCid] = useState(loginuser["cid"]);
  const [dummy, setdummy] = useState('');
  const [auclogo, setauclogo] = useState();
  const [pdftyp, setpdftyp] = useState();
  const [pdfshow, setpdfshow] = useState(false);
  const [auclogopath, setauclogopath] = useState();
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const aucteamrefs = useRef([]);
  const [aucteambase64, setaucteambase64] = useState([]);
  const [auctotalpoint, setauctotalpoint] = useState('');
  const updtoken = useSelector((state) => state.updtoken);
  
  const aucmoredetail = useSelector((state) => state.actmoredata);


  const history = useHistory({ forceRefresh: true });
  // const teamlist = localStorage.getItem("list")

  const fetchData = async () => {
    setActive(true);

    var hdr = {
      params: {
        frm: 1,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listTeam({}, hdr)
      .then((res) => {
        let response = res.data;
        console.log('team list response.............................')
        console.log(response)

        if (response.success == true) {
          let responsedata = response.data;
          setData(responsedata);
          console.log(responsedata)
          setpath(responsedata.path)
          dispatch(teamlistData({ responsedata: withAuctionAid(responsedata, aid) }));
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });
  };
  const fetchaucData = async () => {
    // //  console.log('data auc fetc')
    setActive(true);
    // //  console.log("fetch cid:" + cid);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.listAuction({ myauction: 1 }, hdr)
      .then((res) => {
        let response = res.data;
        // //  console.log('auct data response')
        // //  console.log(response)

        if (response.success == true) {
          let responsedata = response.data;
          //  console.log(responsedata)
          setaucdata(responsedata.list.filter((ele) => ele.aid == aid)[0])
          //  console.log('responsedata.list.filter((ele) => ele.aid == aid)[0]')
          //  console.log(responsedata.list.filter((ele) => ele.aid == aid)[0])

          setauclogo(responsedata.list.filter((ele) => ele.aid == aid)[0].logo)
          // //  console.log(responsedata.list.filter((ele) => ele.aid == aid)[0].player)
          setaucplayer(responsedata.list.filter((ele) => ele.aid == aid)[0].player)
          setauctotalpoint(responsedata.list.filter((ele) => ele.aid == aid)[0].totalpoint)
          setauclogopath(responsedata.path)
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });
  };
  const fetchplData = async () => {
    // //  console.log("aiiiiiid")
    // //  console.log(aid)
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded", //v
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listPlayer({ self: 1 }, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;
          // //  console.log(responsedata)
          if (!responsedata.aid) responsedata.aid = aid;
          setplData(responsedata);
          dispatch(playerlistData({ responsedata: withAuctionAid(responsedata, aid) }));
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        setActive(false);
      });


  };

  const del = useCallback(
    async (vl, status) => {
      // //  console.log(vl);
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            authorization: JSON.stringify([
              { cid: cid, aid: aid, token: loginuser["token"] },
            ]),
          },
        };

        await DataService.deleteTeam({ tid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;

            if (response.success == true) {
              const db = getDatabase();

              set(ref(db, 'map/info/' + aid), { "type": "2", "upd": "3", 'id': vl, "detail": "", "tkn": updtoken });

              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });
              const updatedList = (data?.list || []).filter((ele) => ele.tid != vl);
              // Update local component state immutably
              setData({ path: data?.path, aid: data?.aid, list: updatedList });
              // Sync Redux cache immutably
              dispatch(
                teamlistData({
                  responsedata: { path: data?.path, aid: data?.aid, list: updatedList },
                })
              );
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }

            setActive(false);
          })
          .catch(() => {
            //  console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [aid, cid, dispatch, loginuser, updtoken, data]
  );

  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };
  const firechange = (datasnap) => {
    // //  console.log("firechange")
    if (datasnap.type == "2" && datasnap.upd == "1") {
      if (getpageData != 0) {
        // //  console.log("lol ")

        let responsedata = {};
        var newdata = {
          'tid': datasnap.id,
          'logo': datasnap.detail.logo,
          'name': datasnap.detail.name,
          'sname': datasnap.detail.srtname,
          'srtkey': datasnap.detail.srtkey,

        }
        // //  console.log("lol2 ")
        // //  console.log(newdata)


        responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: [newdata, ...getpageData.responsedata.list],
          },
        };
        // //  console.log(responsedata)
        setData(responsedata.responsedata)

        dispatch(teamlistData(responsedata));

      }

    }
    if (datasnap.type == "2" && datasnap.upd == "2") {
      // //  console.log("firechange edit")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter(
          (ele, ind) => {
            if (ele.tid == datasnap.id) {
              ele.logo = datasnap.detail.logo;
              ele.name = datasnap.detail.name;
              ele.sname = datasnap.detail.srtname;
              ele.srtkey = datasnap.detail.srtkey;
              ele.color = datasnap.detail.color;
              ele.forcolor1 = datasnap.detail.color1;
              ele.forcolor2 = datasnap.detail.color2;
              ele.forcolor3 = datasnap.detail.color3;
              ele.forcolor4 = datasnap.detail.color4;


            }

            return ele;
          }
        );
        // //  console.log(updateitem)



        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        dispatch(teamlistData(responsedata));

      }


    }
    if (datasnap.type == "2" && datasnap.upd == "3") {
      // //  console.log("firechange del")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele, ind) => {
          return ele.tid != datasnap.id;
        });
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedata);

        dispatch(teamlistData(responsedata));

      }

    }
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + 'my-auction')
    }
    if ((datasnap.type == "1" && datasnap.upd == "4") || (datasnap.type == "2" && datasnap.upd == "4")) {
      setData(getpageData.responsedata)
    }

  }
  const fetchcatData = async () => {
    // //  console.log("catdata fetch hua")
    // setActive(true);

    var hdr = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "authorization": JSON.stringify([{ 'cid': cid, 'token': loginuser["token"] }])
      }
    }

    await DataService.listCategory({ 'aid': aid }, hdr)
      .then(res => {

        let response = res.data;
        //  console.log(response)
        if (response.success == true) {
          // //  console.log(responsedata)
          let responsedata = response.data;
          // //  console.log(" cat list kya h");
          // //  console.log(responsedata.list.sort((a, b) => a.catord - b.catord));

          setcatData(responsedata.list.sort((a, b) => a.catord - b.catord));
          dispatch(catlistData({ responsedata: withAuctionAid(responsedata, aid) }));
        }
        // setActive(false);

      }).catch(() => {
        //  console.log('Not valid')
        // setActive(false);
      })
  };
  useEffect(() => {
    localStorage.removeItem('isFirstMount');

    if (getaucdata == 0) {
      fetchaucData()
    } else {
      setaucplayer(getaucdata.responsedata.list.filter((ele) => ele.aid == aid)[0].player)
      setauclogo(getaucdata.responsedata.list.filter((ele) => ele.aid == aid)[0].logo)
      setauctotalpoint(getaucdata.responsedata.list.filter((ele) => ele.aid == aid)[0].totalpoint)
      setauclogopath(getaucdata.responsedata.path);
      setaucdata(getaucdata.responsedata.list.filter((ele) => ele.aid == aid)[0])
    }

    if (!canReuseAuctionList(getplayerpageData, aid)) {
      fetchplData()
    } else {
      setplData(getplayerpageData.responsedata)
      if (!getplayerpageData.responsedata.aid) {
        dispatch(playerlistData({
          responsedata: withAuctionAid(getplayerpageData.responsedata, aid),
        }))
      }
    }

    if (!canReuseAuctionList(getcatpageData, aid)) {
      fetchcatData()
    } else {
      const list = getcatpageData.responsedata.list || []
      setcatData([...list].sort((a, b) => a.catord - b.catord))
      if (!getcatpageData.responsedata.aid) {
        dispatch(catlistData({
          responsedata: withAuctionAid(getcatpageData.responsedata, aid),
        }))
      }
    }

    if (!canReuseAuctionList(getpageData, aid)) {
      setData([]);
      fetchData(0);
    } else {
      let responsedata = getpageData.responsedata;
      setData(responsedata);
      setpath(responsedata.path);
      if (!responsedata.aid) {
        dispatch(teamlistData({
          responsedata: withAuctionAid(responsedata, aid),
        }))
      }
    }
  }, []);

  useEffect(() => {
    //  console.log("my upddata");
    //  console.log(upddata);
    if (upddata !== null) {
      //  console.log(upddata)
      //  console.log(isfirsttime)
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "2") {

          dispatch(setisfirsttime(upddata));
        }

      }
    }
  }, [upddata]);
  const dataRef = useRef(data);
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const orderDirtyRef = useRef(false);

  // Local reorder only — keep drag smooth; persist once on drop
  const moveTeam = useCallback((fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return;

    setData((prev) => {
      if (!prev?.list?.length) return prev;
      if (fromIndex >= prev.list.length || toIndex >= prev.list.length) return prev;

      const updatedOrder = [...prev.list];
      const [movedTeam] = updatedOrder.splice(fromIndex, 1);
      updatedOrder.splice(toIndex, 0, movedTeam);

      const next = {
        path: prev.path || path,
        aid: prev.aid || aid,
        list: updatedOrder,
      };
      // Keep ref in sync immediately so drag-end persist sees latest order
      dataRef.current = next;
      orderDirtyRef.current = true;
      dispatch(teamlistData({ responsedata: next }));
      return next;
    });
  }, [aid, path, dispatch]);

  const persistTeamOrder = useCallback(async () => {
    if (!orderDirtyRef.current) return;
    orderDirtyRef.current = false;

    const list = dataRef.current?.list;
    if (!list?.length) return;

    const torder = list.map((ele) => ele.tid).join(",");
    const hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    try {
      const res = await DataService.setteamorder({ aid: aid, ids: torder }, hdr);
      if (res?.data?.success !== true) {
        toast.error(res?.data?.msg || "Failed to save team order", {
          theme: "colored",
          position: "bottom-center",
        });
      }
    } catch {
      toast.error("Failed to save team order", {
        theme: "colored",
        position: "bottom-center",
      });
    }
  }, [aid, cid, loginuser]);
  const convertaucteamtobase64 = (img, index) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;

    ctx.drawImage(img, 0, 0, img.width, img.height);


    const base64Data2 = canvas.toDataURL('image/jpeg');

    if (base64Data2) {

      const newarr2 = aucteambase64;
      newarr2[index] = base64Data2
      setaucteambase64(newarr2);

    }

  };
  const handleaucimgload = (index) => {

    return () => {

      convertaucteamtobase64(aucteamrefs.current[index], index);


    };
  };

  function linechanger(str, count) {
    var plsp = str.split(" ")
    let plsplen = 0;
    let whichsp = 0;
    let firststr = "";
    let secstr = "";
    for (let i = 0; i < plsp.length; i++) {
      plsplen += plsp[i].length;

      if (plsplen > count) {

        break;
      }
      whichsp += 1

    }
    var linearr = []
    for (let y = 0; y < whichsp; y++) {
      if (firststr !== '') {
        firststr += " "
      }
      firststr += plsp[y];
    }
    linearr.push(firststr)

    for (let z = whichsp; z < plsp.length; z++) {
      if (secstr !== '') {
        secstr += " "
      }
      secstr += plsp[z];
    }
    linearr.push(secstr)
    return linearr
  }

  function teampdf() {
    // Sample data

    const doc = new jsPDF();
    if (data != '') {


      data.list.map((ele) => {
        //  console.log(ele)
        if (aucteambase64[0]) {
          doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 30, 30);

        }
        else {
          doc.addImage(teamdefaultLogo, 'JPEG', 10, 10, 30, 30);
        }
        if (aucteambase64[ele.tid]) {
          doc.addImage(aucteambase64[ele.tid], 'JPEG', 170, 10, 30, 30);

        } else {

          doc.addImage(teamdefaultLogo, 'JPEG', 170, 10, 30, 30);
        }

        doc.setDrawColor(227, 225, 225);
        doc.rect(9.5, 9.5, 31, 31);

        doc.setDrawColor(227, 225, 225);
        doc.rect(169.5, 9.5, 31, 31);

        doc.setTextColor(0, 0, 0);
        doc.setFontSize(16);
        doc.setFont("Helvetica", "bold");

        if (acname.length < 27) {

          let alen = acname.length * 4
          // doc.setTextColor(196, 147, 14);

          doc.text(acname.toUpperCase(), 105 - alen / 2, 25);
          // doc.setTextColor(255, 255, 255);

        }
        else {
          doc.setFontSize(15);

          var fstr = linechanger(acname, 27)
          let alen1 = fstr[0].length * 3.2

          doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 25);
          if (fstr[1].length <= 25) {
            doc.setFontSize(14);

            let alen2 = fstr[1].length * 2.9

            doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 30);
          } else {
            var fsstr = linechanger(fstr[1], 25);
            doc.setFontSize(14);

            let alen2 = fsstr[0].length * 2.9;
            let alen3 = fsstr[1].length * 2.9;
            doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 30);
            doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 35);

          }


        }
        var teamname = ele.name
        doc.setFontSize(12);
        doc.setFont("Helvetica", "bold");

        let tlen = teamname.length * 2
        doc.text(teamname.toUpperCase(), 95 - tlen / 2, 40);
        doc.setFontSize(9);

        doc.text('PLAYERS : ' + players, 10, 49);
        console.log('aucdata')
        console.log(aucdata)
        if (aucdata?.unit != "" && aucdata?.unit != null) {
          //  console.log(aucdata.unit)

          doc.text('POINT : ' + auctotalpoint + ' '+aucdata.unit, 170, 49);
        }
        else {
          //  console.log(aucdata?.unit)

          doc.text('POINT : ' + auctotalpoint, 170, 49);
        }

        doc.setDrawColor(227, 225, 225);
        var startYuniversal = 50.5
        var rowincr = 20
        var headersY = 10
        // var players=17;
        if (players > 10) {
          rowincr = 200 / players
        }
        var startY = 50.5
        var startYpldata = 50.5
        for (var i = 1; i <= parseInt(players) + 1; i++) {

          doc.rect(9.5, startY, 190.5, rowincr);

          startY += rowincr
          if (i <= players) {
            doc.text(`${i}`, 13.2, startY + rowincr / 2);
          }

        }
        if (pldata != '') {

          doc.setFontSize(10);
          if (players > 17) {
            doc.setFontSize(9);
          }
          doc.setFont("Helvetica", "normal");
          var teamplayers = pldata.list.filter((pl) => {

            if (pl.tmid == ele.tid) {
              return pl
            }
          })
          if (teamplayers.length > 0) {
            var rem = auctotalpoint
            teamplayers.map((player) => {
              //  console.log(player)
              // //  console.log(auctotalpoint)
              // //  console.log(player.points)
              // //  console.log(String(parseInt(auctotalpoint) - parseInt(player.points)))
              doc.text(player.pname, 30, startYpldata + rowincr + rowincr / 1.8);
              // if()
              console.log('players')
              console.log(player)

              if (aucdata?.unit != "" && aucdata?.unit != null) {
                var plpoint = Number(player.points);
                doc.text(plpoint.toFixed(aucdata?.isdecm) + ' ' + aucdata.unit, 125, startYpldata + rowincr + rowincr / 1.8);
                doc.text(Number(rem - player.points).toFixed(aucdata?.isdecm) + ' ' + aucdata.unit, 165, startYpldata + rowincr + rowincr / 1.8);
              }
              else {
                doc.text(Number(player.points).toFixed(aucdata?.isdecm), 125, startYpldata + rowincr + rowincr / 1.8);
                doc.text(Number(rem - player.points).toFixed(aucdata?.isdecm) , 165, startYpldata + rowincr + rowincr / 1.8);
              }
              startYpldata += rowincr
              rem -= player.points
            })
          }
        }



        if (players >= 17) {
          headersY = 5
        }
        doc.setFontSize(10);
        if (players > 17) {
          doc.setFontSize(8);
        }
        doc.setFont("Helvetica", "bold");

        doc.text('S.no', 12.2, startYuniversal + headersY);
        doc.text('NAME', 60, startYuniversal + headersY);
        doc.text('POINT', 125, startYuniversal + headersY);
        doc.text('BALANCE', 160.5, startYuniversal + headersY);
        doc.text('T', 192.5, startYuniversal + headersY);

        // //  console.log(startY)
        doc.rect(9.5, startYuniversal, 12.5, startY - startYuniversal);
        doc.rect(9.5, startYuniversal, 105.5, startY - startYuniversal);
        doc.rect(9.5, startYuniversal, 139.5, startY - startYuniversal);
        doc.rect(9.5, startYuniversal, 180.5, startY - startYuniversal);
        doc.rect(9.5, startYuniversal, 190.5, startY - startYuniversal);
        console.log('aucmoredetail.............................')
        console.log(aucmoredetail)
        if(aucmoredetail?.more[0].iswhite != 1){

          doc.addImage(applogo, 'PNG', 85, startY + 7, 45, 15.79);
        }

        doc.addPage();

      })

      doc.save(acname.toUpperCase() + '_TEAM_PLIST.pdf');
    }
    else {
      alert('No data !!')
    }
  }
  function catwiseteampdf() {
    // Sample data
    if (catdata != "") {

      const doc = new jsPDF();
      if (data != '') {


        data.list.map((ele) => {
          // //  console.log(ele)
          if (aucteambase64[0]) {
            doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 30, 30);

          }
          else {
            doc.addImage(teamdefaultLogo, 'JPEG', 10, 10, 30, 30);
          }
          if (aucteambase64[ele.tid]) {
            doc.addImage(aucteambase64[ele.tid], 'JPEG', 170, 10, 30, 30);

          } else {

            doc.addImage(teamdefaultLogo, 'JPEG', 170, 10, 30, 30);
          }

          doc.setDrawColor(227, 225, 225);
          doc.rect(9.5, 9.5, 31, 31);
          doc.rect(9, 9, 31, 31);
          doc.setDrawColor(12, 2, 3);

          doc.rect(2, 2, 205, 290);

          doc.setDrawColor(227, 225, 225);
          doc.rect(169.5, 9.5, 31, 31);
          doc.rect(169, 9, 31, 31);

          doc.setTextColor(0, 0, 0);
          doc.setFontSize(16);
          doc.setFont("Helvetica", "bold");

          if (acname.length < 27) {

            let alen = acname.length * 4
            // doc.setTextColor(196, 147, 14);

            doc.text(acname.toUpperCase(), 105 - alen / 2, 25);
            // doc.setTextColor(255, 255, 255);

          }
          else {
            doc.setFontSize(15);

            var fstr = linechanger(acname, 27)
            let alen1 = fstr[0].length * 3.2

            doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 25);
            if (fstr[1].length <= 25) {
              doc.setFontSize(14);

              let alen2 = fstr[1].length * 2.9

              doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 30);
            } else {
              var fsstr = linechanger(fstr[1], 25);
              doc.setFontSize(14);

              let alen2 = fsstr[0].length * 2.9;
              let alen3 = fsstr[1].length * 2.9;
              doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 30);
              doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 35);
            }
          }
          var teamname = ele.name
          doc.setFontSize(12);
          doc.setFont("Helvetica", "bold");

          let tlen = teamname.length * 2
          doc.text(teamname.toUpperCase(), 95 - tlen / 2, 40);
          doc.setFontSize(9);

          var YTop = 60;
          var minplsum = 0;
          var rowY = 10
          var font = 14
          var headpad = 7

          // //  console.log(rowY)
          if (players > 10 && players < 15) {
            YTop = 60;
            rowY = 8.5
            font = 12
            headpad = 5
          }
          else if (players > 15 && players < 20) {
            YTop = 50;
            rowY = 8
            font = 10
            headpad = 5

          }
          else if (players > 20) {
            YTop = 50;
            rowY = 6.5
            font = 8
            headpad = 4

          }
          catdata.map((ele) => {
            if (ele.plno != '0' || ele.minplno != '0') {


              // //  console.log(ele)
              // //  console.log(YTop)
              doc.setFillColor(17, 20, 64);
              doc.rect(40, YTop, 130, rowY, 'F');
              doc.setFontSize(font);
              doc.setTextColor("#fff");
              doc.text(ele.cname, 70, YTop + headpad);
              doc.text('Amount', 140, YTop + headpad);
              var Ysubtop = YTop + rowY;
              if (parseInt(ele.plno) > 0) {
                var c = parseInt(ele.plno)
              }
              else {
                var c = parseInt(ele.minplno)

              }
              for (var i = 1; i <= c; i++) {
                doc.setTextColor("black");
                doc.rect(40, Ysubtop, 130, rowY);
                doc.rect(40, Ysubtop, 90, rowY);
                Ysubtop = Ysubtop + rowY;
              }
              YTop = Ysubtop + rowY;
              minplsum += parseInt(ele.minplno);
            }
          })
          // //  console.log(players)
          // //  console.log(minplsum)
          var j = players - minplsum
          // //  console.log(j)
          var Ysubtop = YTop
          for (var i = 0; i <= j; i++) {
            // //  console.log(Ysubtop)
            doc.setTextColor("black");
            doc.rect(40, Ysubtop, 130, rowY);
            doc.rect(40, Ysubtop, 90, rowY);
            Ysubtop = Ysubtop + rowY;
          }

          if(aucmoredetail?.more[0].iswhite != 1){
            doc.addImage(applogo, 'PNG', 85, 270, 45, 15.79);
          }
          doc.addPage();

        })

        doc.save(acname.toUpperCase() + '_TEAM_CATEGORIES_LIST.pdf');
      }
      else {
        alert('No data !!')
      }
    }
    else {
      alert(' There is No category !!')
    }
  }
  

  const copyAllTeams = () => {
    if (!data.list || data.list.length === 0) {
      toast.error("No teams available to copy!", {
        theme: "dark",
        position: "bottom-center",
      });
      return;
    }

    const auctionName = localStorage.getItem("auction_name") || "Auction";
    let allTeamsInfo = `*${auctionName.toUpperCase()} - ALL TEAMS*\n\n`;
    
    data.list.forEach((team, index) => {
      allTeamsInfo += `${index + 1}. *${team.name}*\n`;
      allTeamsInfo += `   Short Name: ${team.sname}\n`;
      allTeamsInfo += `   Short Key: ${team.srtkey}\n\n`;
    });
    
    navigator.clipboard.writeText(allTeamsInfo).then(() => {
      toast.success("All teams info copied to clipboard!", {
        theme: "dark",
        position: "bottom-center",
      });
    }).catch(() => {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = allTeamsInfo;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      
      toast.success("All teams info copied to clipboard!", {
        theme: "dark",
        position: "bottom-center",
      });
    });
  };

  const handleExport = () => {

    
    if (!data.list || data.list.length === 0) {
      alert("No data available for export.");
      return;
    }

    const auctionId = localStorage.getItem("auction_id");
    const auctionName = localStorage.getItem("auction_name");
    // const team = localStorage.getItem("team");
  
    // Create dynamic filename
    const fileName = `${auctionId}_${auctionName} (teams).xlsx`;
    
    const formattedData = data.list?.map(({ logo, name, sname, srtkey }) => ({
      "Logo": logo,
      "Team Name": name || "N/A",
      "S Name": sname || "N/A",
      "Short Name": srtkey || "N/A", 
    }));

    console.log("Formatted Data for Excel:", formattedData);

    const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // AUTO ADJUST COLUMN WIDTHS BASED ON CONTENT LENGTH
  const columnWidths = Object.keys(formattedData[0]).map((key) => ({
    wch: Math.max(
      key.length, // Header length
      ...formattedData.map((row) => (row[key] ? row[key].toString().length : 0)) // Max content length
    ) + 2, // Adding extra space
  }));

  worksheet["!cols"] = columnWidths; // Apply auto-calculated column widths

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Teams");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, fileName);
  };

    // "name": values.name,
    // "srtname": values.srtname,
    // "srtkey": values.srtkey,
    // if (!Players || Players.length === 0) {
    //   alert("No data available for export.");
    //   return;
    // }

    // const worksheet = XLSX.utils.json_to_sheet(Players);
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    // const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    // saveAs(dataBlob, `${fileName}.xlsx`);
  


 
  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        {pdfshow && <>
          <div className="pdfdiv"></div>
          <div className="pdfpopup">
            <div className="pdoptline2">
              <div className="pdopt5">
                <select class="form-select" value={pdftyp} onChange={(e) => setpdftyp(e.target.value)} aria-label="Default select example">
                  <option selected hidden default disabled value="">All Players</option>
                  <option value="1">All Players</option>
                  <option value="2">Category wise</option>
                </select>
              </div>


            </div>
            <button className='btn btn-primary pdclose' onClick={() => setpdfshow(false)} >Close</button>
            <button className='btn btn-primary pddwn' onClick={() => { pdftyp == '1' ? teampdf() : pdftyp == '2' ? catwiseteampdf() : teampdf() }}>Download PDF</button>
          </div>
        </>
        }
        <div>
          <p>{dummy}</p>
          <Navigationtitle data={match} />
          <div id="top-categories" className="top-cat-area  bottom-less">
            <div className="container-fluid padding-left-0px">
              <section
                id="advisor"
                className="advisor-area default-padding bottom-less"
              >
                <img
                  ref={(img) => {
                    aucteamrefs.current['0'] = img
                    handleaucimgload(0)
                  }}
                  style={{ display: 'none' }}
                  onLoad={handleaucimgload(0)}
                  fallback={
                    <Shimmer
                      width={"100%"}
                      height={"auto"}
                    />
                  }
                  src={auclogopath + auclogo + '?c'}
                  alt="base img" crossOrigin="Anonymous" />
                {data != "" && data.list.map((ele) => {
                  return (<img style={{ display: 'none' }} src={data.path + ele.logo + '?c'}
                    ref={(img) => { aucteamrefs.current[ele.tid] = img; handleaucimgload(ele.tid) }}
                    onLoad={handleaucimgload(ele.tid)}
                    alt="base img" crossOrigin="Anonymous" />)
                })}

                <div className="container-fluid">
                  <div className="row">
                    <button onClick={() => setislist(!islist)} className="listteam mydesbtn">{!islist ? <FontAwesomeIcon icon={faList} /> : <FontAwesomeIcon icon={faTableCellsLarge} />}</button>
                    <button onClick={copyAllTeams} className="mydesbtn copy-all-btn" title="Copy all teams info">
                      <FiIcons.FiCopy size={"16px"} style={{ marginRight: "5px" }} />
                     
                    </button>
                    <button onClick={() => setpdfshow(true)} className="team-pdf-btn ">PDF</button>
                    <button onClick={handleExport} className="mydesbtn excel-btn" >EXCEL</button>
                    {/* <button onClick={() => transfertoscore()} className="team-pdf-btn2 ">Transfer</button> */}
                    {/* <button onClick={() => catwiseteampdf()} className="team-cat-btn">CATEGORY WISE PDF</button> */}
                    {islist == false && <div className="advisor-items text-center text-light">
                      {data != "" ? (
                        data.list?.map((dt, key) => {
                          console.log("-----",data.path + dt.logo);
                          
                          return (
                            <div className="col-md-4 col-sm-6 col-xs-12 single-item tsingle">
                              <div className="advisor-item">
                                <div className="info-box">
                                  <div className="team-logo">
                                    <Image
                                      fallback={
                                        // <Shimmer width={"100%"} height={225} />
                                        teamdefaultLogo
                                      }
                                      src={
                                        dt.logo == "" || dt.logo == null
                                          ? teamdefaultLogo
                                          : data.path + dt.logo
                                      }
                                    ></Image>
                                  </div>
                                  <div
                                    className="info-title team-heading"
                                    title={data.path}
                                  >
                                    <div className="thead">
                                      <h2 style={{ color: "#757575" }}>
                                        {dt.name.charAt(0).toUpperCase() + dt.name.slice(1)}
                                      </h2>
                                    </div>


                                    <div className="my-acution-bottom row">

                                      <div className="col-md-12 text-align aucbottom catbottom" style={{ 'display': 'flex' }}>
                                        <div className="lbl1" >
                                          <div title="Short Name">
                                            <span className="snnn">S-name : &nbsp;</span> {" "}
                                            {dt.sname}
                                          </div>
                                          <div title="Short key">
                                            {" "}<span className="snnn">S-key : &nbsp; </span>
                                            {dt.srtkey}
                                          </div>

                                        </div>
                                        <div className="lbl2">

                                          <Link
                                            style={{
                                              color: "#186cc2",
                                              padding: "0 18px",
                                            }}
                                            // onClick={() => setauction(dt.aid, dt.aname, dt.atm)}
                                            to={"/edit-auction-team/" +
                                              encode(dt.tid)}
                                          >
                                            <AiIcons.AiOutlineEdit
                                              size={"20px"}
                                              style={{ color: "green" }}
                                            />
                                          </Link>
                                          <button
                                            type="button"
                                            onClick={() => deldata(dt.tid)}
                                            style={{ background: 'transparent', border: 'none', padding: 0, color: 'red', cursor: 'pointer' }}
                                            aria-label="Delete team"
                                          >
                                            <AiIcons.AiOutlineDelete size={"20px"} />
                                          </button>
                                        </div>
                                      </div>
                                    </div>




                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <NotFound data={isActive} />
                      )
                      }
                    </div>}
                    {islist == true && <>
                      <div className="teamcontainer">
                        <h3>You can re-order teams simply by drag and place</h3>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                          {data != "" && data.list?.map((team, index) => (
                            <DraggableTeamRow
                              key={team.tid}
                              team={team}
                              index={index}
                              path={data.path || path}
                              moveTeam={moveTeam}
                              onDragEnd={persistTeamOrder}
                              onDelete={deldata}
                            />
                          ))}
                        </ul>
                      </div>
                    </>
                    }

                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </LoadingOverlay >
    </>
  );
}

export default Team;
